var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupeeImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.5H8V2H1.5V0.5ZM0 3H8V4.5H0V3Z",
    fill: "#07AFA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2205 7.5H2.25C4.0605 7.5 6 6.0935 6 4C6 1.9065 4.0605 0.5 2.25 0.5H0V2H2.25C3.1935 2 4.5 2.6955 4.5 4C4.5 5.3045 3.1935 6 2.25 6H0V7.6015L5.2795 12H7.6215L2.2205 7.5Z",
    fill: "#07AFA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeImg);
export default __webpack_public_path__ + "static/media/rupee-img.421c8e4fc05cdaa6235212cfe158513d.svg";
export { ForwardRef as ReactComponent };